
<!-- <div class="lds-container mt-2">
<lds-progress-spinner *ngIf="loading2"></lds-progress-spinner>
<canvas id="energyOverallGraph" [hidden]="!barChart">{{barChart}}</canvas>
<p class="no-data-text" *ngIf="noData && !user.loading">No Data</p>
<p *ngIf="user.loading">Loading...</p>
</div>

<div class="lds-container mt-2">
  <div class="graph-container" [style.visibility]="loading1 ? 'hidden' : 'visible' ">
    <div [ngStyle]="{'opacity': noData ? '0' : '1'}" class="lw-container" #line>
    </div>
    <p class="no-data-text" *ngIf="noData && !user.loading">No Data</p>
    <p *ngIf="user.loading">Loading...</p>
  </div>
  <canvas id="pieGraph" [hidden]="!pieChart">{{pieChart}}</canvas>
  <lds-progress-spinner *ngIf="loading1"></lds-progress-spinner>
</div> -->

<div class="lds-container mt-2">
  <div class="graph-container" [style.visibility]="loading1 ? 'hidden' : 'visible' ">
    <div [ngStyle]="{'opacity': noData ? '0' : '1'}" class="lw-container">
      <canvas id="energyOverallGraph" [hidden]="!barChart">{{barChart}}</canvas>
    </div>
    @if (noData && !user.loading) {
      <p class="no-data-text">No Data</p>
    }
    @if (user.loading) {
      <p>Loading...</p>
    }
  </div>
  @if (loading1) {
    <lds-progress-spinner></lds-progress-spinner>
  }
</div>

<div class="lds-container mt-2">
  @if (loading2) {
    <lds-progress-spinner></lds-progress-spinner>
  }
  <div [ngStyle]="{'opacity': noData ? '0' : '1'}" class="SD-graph">
    <canvas id="pieGraph" [hidden]="!pieChart">{{pieChart}}</canvas>
  </div>
  @if (noData && !user.loading) {
    <p class="no-data-text">No Data</p>
  }
  @if (user.loading) {
    <p>Loading...</p>
  }
</div>



<div class="export">
  <button class="lds-btn" id="export-button" (click)="onExportClick()">Export Data</button>
</div>